import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function uniqueClientUnitIdFromListValidator(existingIds: string[], currentId?: string | null): ValidatorFn {
  const otherIds = new Set(existingIds.filter(id => id !== currentId));
  return (control: AbstractControl<string | null>): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    return otherIds.has(control.value) ? { duplicateClientUnitId: true } : null;
  };
}
